import { mapActions, mapGetters } from 'vuex';
import { addToMyContacts, removeContacts, toggleFavorite } from '@/api/contact';
import colourMixin from '@/mixins/colour';
export default {
  mixins: [colourMixin],
  data () {
    return {
      inContactOperation: false,
      inFavOperation: false
    };
  },
  computed: {
    ...mapGetters('AppStore', {
      inMeeting: 'inMeeting'
    }),
    ...mapGetters('AuthStore', {
      user: 'profile'
    }),
    isBusy () {
      return this.recent
        ? this.contact.contact &&
            this.contact.contact.presence &&
            this.contact.contact.userstatus === 2
        : this.contact &&
            this.contact.presence &&
            this.contact.userstatus === 2;
    },
    isFavorited () {
      return this.recent
        ? this.contact.contact && this.contact.contact.isfav
        : this.contact && this.contact.isfav;
    },
    isOffline () {
      return !(this.isOnline || this.isBusy);
    },
    isOnline () {
      return this.recent
        ? this.contact.contact &&
            this.contact.contact.presence &&
            this.contact.contact.userstatus === 1
        : this.contact &&
            this.contact.presence &&
            this.contact.userstatus === 1;
    },
    isSuperEasy () {
      return this.user && this.user.supereasymode;
    },
    colorCode () {
      return this.getColorCode(this.contact);
    }
  },
  methods: {
    ...mapActions('ContactStore', {
      addContactsStore: 'addContacts',
      removeContactStore: 'removeContact',
      updateContactStore: 'updateContact'
    }),
    async onAddToContact () {
      this.inContactOperation = true;
      let result = null;
      try {
        result = await addToMyContacts(this.contact);
      } catch (error) {}
      if (result) {
        this.$eventBus.$emit('sendToControls', {
          type: 'task',
          scope: 'contact',
          data: {
            task: 'addContactsStore',
            param: result.contacts || []
          }
        });
        await this.addContactsStore(result.contacts || []);
        this.$eventBus.$emit('add-to-contact', result.contacts[0]);
      }
      this.inContactOperation = false;
    },
    async onAddToFav () {
      this.inFavOperation = true;
      let result = null;
      try {
        if (this.contact.isMyContact) {
          result = await toggleFavorite(this.contact);
        } else {
          result = await addToMyContacts(this.contact, true);
        }
      } catch (error) {}
      if (result) {
        if (this.contact.isMyContact) {
          this.$eventBus.$emit('sendToControls', {
            type: 'task',
            scope: 'contact',
            data: {
              task: 'updateContactStore',
              param: {
                id: this.contact.id,
                isfav: true
              }
            }
          });
          await this.updateContactStore({
            id: this.contact.id,
            isfav: true
          });
          this.$eventBus.$emit('add-to-fav', this.contact);
        } else {
          this.$eventBus.$emit('sendToControls', {
            type: 'task',
            scope: 'contact',
            data: {
              task: 'addContactsStore',
              param: result.contacts || []
            }
          });
          await this.addContactsStore(result.contacts || []);
          this.$eventBus.$emit('add-to-contact', result.contacts[0]);
        }
      }
      this.inFavOperation = false;
    },
    async onRemoveContact () {
      this.inContactOperation = true;
      let result = null;
      try {
        result = await removeContacts(this.contact);
      } catch (error) {}
      if (result) {
        this.$eventBus.$emit('sendToControls', {
          type: 'task',
          scope: 'contact',
          data: {
            task: 'removeContactStore',
            param: this.contact
          }
        });
        await this.removeContactStore(this.contact);
        this.$eventBus.$emit('remove-contact', this.contact);
      }
      this.inContactOperation = false;
    },
    async onRemoveFav () {
      this.inFavOperation = true;
      let result = null;
      try {
        result = await toggleFavorite(this.contact);
      } catch (error) {}
      if (result) {
        this.$eventBus.$emit('sendToControls', {
          type: 'task',
          scope: 'contact',
          data: {
            task: 'updateContactStore',
            param: {
              id: this.contact.id,
              isfav: false
            }
          }
        });
        await this.updateContactStore({
          id: this.contact.id,
          isfav: false
        });
        this.$eventBus.$emit('remove-fav', this.contact);
      }
      this.inFavOperation = false;
    },
    hashCode (str) {
      let hash = 0;
      let i;
      let chr;
      if (str.length === 0) return hash;
      for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
      }
      return Math.abs(hash);
    }
  }
};
